import { DateTime } from "luxon";
import Page from "./page";

// Type for YAML-based newsletters
export interface YamlNewsletter {
  id: string;
  date: string;
  title?: string;
  description?: { description?: string } | string;
  createdAt?: string;
  updatedAt?: string;
  featured?: any;
  articles?: any[];
  news?: any[];
  sys?: {
    createdAt: string;
    updatedAt: string;
  };
}

export default class Newsletter {
  id: string;
  date: string;
  title: string;
  description: string;
  createdAt: DateTime;
  updatedAt: DateTime;
  featured: any;
  articles: Page[];
  news: Page[];

  constructor(newsletter: YamlNewsletter) {
    this.id = newsletter.id;
    this.date = newsletter.date;
    this.title = newsletter.title || "";
    this.description =
      typeof newsletter.description === "string"
        ? newsletter.description
        : newsletter.description?.description || "";

    // Use sys dates if available, otherwise use direct dates
    const createdAt =
      newsletter.sys?.createdAt ||
      newsletter.createdAt ||
      new Date().toISOString();
    const updatedAt =
      newsletter.sys?.updatedAt ||
      newsletter.updatedAt ||
      new Date().toISOString();

    this.createdAt = DateTime.fromISO(createdAt).setZone("Asia/Tokyo");
    this.updatedAt = DateTime.fromISO(updatedAt).setZone("Asia/Tokyo");

    this.featured = new Page(newsletter.featured);
    this.articles = newsletter.articles
      ? newsletter.articles.map((article) => new Page(article))
      : [];
    this.news = newsletter.news
      ? newsletter.news.map((news) => new Page(news))
      : [];
  }
}
